<template>
  <section>
    <router-view></router-view>

    <section>
      <h3 class="t-text-center t-text-2xl t-font-semibold t-mb-2 md:t-text-left">
        Cancelled Bookings
      </h3>

      <booking-card
          v-for="booking in bookings"
          :key="booking.id"
          :booking="booking"
          :booking-status="'CANCELLED'"
          class="t-mb-8"
      />

      <p v-if="!isLoadingBookings && bookings && bookings.length === 0" class="t-text-xl t-flex t-text-gray-700 t-justify-center t-mt-4">
        No Bookings To Show
      </p>
      <p v-else-if="isLoadingBookings" class="t-text-xl t-flex t-text-gray-700 t-justify-center t-mt-4">
        Loading...
      </p>

      <paginate
        v-if="bookings && pagination && pagination.pageCount > 1"
        :page-count="pagination.pageCount"
        :page-range="pagination.pageRange"
        :margin-pages="pagination.marginPages"
        :click-handler="fetchCancelledBookings"
        :prev-text="'&laquo;'"
        :next-text="'&raquo;'"
        :prev-link-class="'page-link'"
        :next-link-class="'page-link'"
        :container-class="'pagination'"
        :page-class="'page-item'"
        :page-link-class="'page-link'"
        class="t-flex t-justify-end t-mb-4"
      />
    </section>
  </section>
</template>

<script>
import BookingCard from "../BookingCard";
import Paginate from "vuejs-paginate";

export default {
  name: 'BookingsCancelledTab',
  description: '',
  components: {
    BookingCard,
    Paginate
  },
  data() {
    return {
      bookings: null,
      pagination: null,
      isLoadingBookings: true
    }
  },
  created() {
    this.fetchCancelledBookings(1);
  },
  methods: {
    fetchCancelledBookings(page) {
      const fetchBookings = async (page) => {
        try {
          this.isLoadingBookings = true;

          let res = await axios.get(`cancelled?page=${page}`);
          let bookings = await res.data.data.map(booking => {
            return booking;
          });

          let pagination = null;
          if (res.data.meta && res.data.meta.pagination) {
            let paginationData = res.data.meta.pagination;
            pagination = {
              itemsPerPage: paginationData.per_page,
              pageCount: paginationData.total_pages,
              pageRange: 4,
              marginPages: 1,
              currentPage: paginationData.current_page
            }
          }
          return [bookings, pagination];
        } catch (error) {
          console.error(error);
          Event.$emit('serverError');
        } finally {
          this.isLoadingBookings = false;
        }
      };

      fetchBookings(page).then(data => {
        this.bookings = data[0];
        this.pagination = data[1];
      })
    }
  }
}
</script>

<style scoped>

</style>